import { render, staticRenderFns } from "./CompanyFilterRefEditor.vue?vue&type=template&id=1b22c826&scoped=true"
import script from "./CompanyFilterRefEditor.vue?vue&type=script&lang=js"
export * from "./CompanyFilterRefEditor.vue?vue&type=script&lang=js"
import style0 from "./CompanyFilterRefEditor.vue?vue&type=style&index=0&id=1b22c826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b22c826",
  null
  
)

export default component.exports